import React from 'react';

import cn from 'classnames';

import Image from 'components/Image';

import { IntlMsgShape } from 'helpers/consts';

interface ITrialReminderTermProps {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  icon: {
    src: string;
    alt: string | IntlMsgShape;
  };
  noVerticalLine?: boolean;
}

const TrialReminderTerm = ({
  icon,
  noVerticalLine,
  subtitle,
  title,
}: ITrialReminderTermProps) => {
  return (
    <div className="relative mb-4">
      {!noVerticalLine && (
        <div
          data-testid="term-vertical-line"
          className={cn('absolute bg-white w-px h-6/5 top-2 left-3.5')}
        />
      )}
      <div className="flex flex-row justify-start relative">
        <div className="absolute flex justify-center items-center bg-soft-sensual-bg">
          <Image src={icon.src} alt={icon.alt} className="!w-7 !h-7" />
        </div>
        <div className="ml-11">{title}</div>
      </div>
      <div className="ml-11 text-left">{subtitle}</div>
    </div>
  );
};

export default TrialReminderTerm;
